const sanitizeMailId = (mailId: string): string => {
  const mailIdWithoutAsterisks = mailId.replace(/\*/g, "");
  if (mailId === "plans") {
    return "";
  }

  return mailIdWithoutAsterisks;
};

export default sanitizeMailId;
